const PORTRAIT = "/images/donja.jpg";

export default function Instructor() {
  return (
    <section id="instructor" data-testid="instructor-section" className="relative py-24 lg:py-32 border-t border-[var(--line)] bg-white">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="eyebrow mb-5">Meet Your Instructor</div>
            <h2 className="font-display text-[44px] sm:text-5xl lg:text-[64px] leading-[1.02] tracking-[-0.035em] text-ink mb-6">
              Strategy meets{" "}
              <span className="font-serif-em italic text-brand font-light">execution.</span>
            </h2>
            <div className="space-y-5 text-[17px] leading-[1.7] text-ink/75">
              <p>
                <strong className="text-ink">Donja Williams</strong> is the Founder and CEO of{" "}
                <strong className="text-ink">Freedom In Me LLC</strong> and the Founder and Executive Director of{" "}
                <strong className="text-ink">Freedom In Me Business Showers</strong>.
              </p>
              <p>
                She is a <strong className="text-ink">corporate consultant</strong>, entrepreneur, strategist, and speaker who helps leaders, organizations, and business owners move with clarity, confidence, and execution.
              </p>
              <p>
                Her approach combines strategy, technology, leadership, and empowerment to help people{" "}
                <strong className="text-ink">stop sitting on ideas</strong> and start moving with intention.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
              <Stat n="F25 / F500" l="Enterprise experience" />
              <Stat n="50+" l="Years combined leadership" />
              <Stat n="Cross-sector" l="Public · private · nonprofit" />
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative">
              <div className="absolute -top-4 -right-4 lg:-top-6 lg:-right-6 w-28 h-28 lg:w-44 lg:h-44 rounded-3xl bg-brand-soft border border-brand/15 -z-0" />
              <div className="absolute -bottom-4 -left-4 lg:-bottom-6 lg:-left-6 w-20 h-20 lg:w-32 lg:h-32 rounded-3xl bg-bone border border-[var(--line)] -z-0" />
              <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-[var(--line)] bg-bone shadow-[0_30px_80px_-30px_rgba(10,10,10,0.2)]">
                <img src={PORTRAIT} alt="Donja Williams — Founder &amp; CEO, Freedom In Me LLC" className="w-full h-full object-cover object-top" />
                <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur rounded-xl border border-[var(--line)] p-4 flex items-center justify-between">
                  <div>
                    <div className="font-display text-base text-ink leading-tight">Donja Williams</div>
                    <div className="text-xs text-ink/65 font-serif-em italic font-light mt-0.5">Founder &amp; CEO, Freedom In Me LLC</div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono-spec text-[10px] tracking-[0.18em] uppercase text-brand">Instructor</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ n, l }) {
  return (
    <div>
      <div className="font-display text-xl text-ink tracking-tight">{n}</div>
      <div className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)] mt-1.5 leading-snug">{l}</div>
    </div>
  );
}
